module.exports = __webpack_public_path__ + "static/tips-for-pm-5127a4c0d1741251fb51400926f53736.png";